<template>
  <v-ons-page @init="setListExpanded(true)" @show="showPage()">

    <div class="content">

      <app-pull-hook :disabled="isSync" @call-api="$emit('call-api', $event)"></app-pull-hook>

      <div v-if="! listStrategie.length" class="content--perfhome content--perfhome__empty">

        <header>
          <img :src="$getBadgeAsset(nbFeuille)">
        </header>
        <section>
          <p>
            Ajoutez vos cultures pour suivre vos prix OS et les cours Euronext.
          </p>
        </section>
        <footer>
          <v-ons-button modifier="large--cta perflarge" @click="$emit('show-home', { id: 'cultures' })">
            Ajouter mes cultures
          </v-ons-button>
        </footer>

      </div>

      <div v-else class="content--perfhome">

        <div v-if="flashHeader" class="content--perfhome__flash">
          <header :style="{'background-image': 'url(' + $apiDomain + '/imgs/' + flashHeader.img + ')'}">
            <span>{{ flashHeader.type }}</span>
          </header>
          <section>
            <p>
              <b>{{ flashHeader.title.replace(/ ([^ ]+)$/, '&nbsp;$1') }}</b>
            </p>
            <template v-for="(item, index) in flashHeader.msg">
              <span v-html="item" :key="index" @click="openFlashLink"></span>
              <br v-if="index < flashHeader.msg.length -1" :key="index"/>
            </template>
            <template v-if="flashHeader.isShort">
              {{ isNoteShort ? '...' : '' }}
              <a href="#" @click="isNoteShort = ! isNoteShort" style="white-space: nowrap">
                {{ isNoteShort ? 'Lire la suite' : 'Réduire' }}
              </a>
            </template>
          </section>
          <footer v-if="flashHeader.ok">
            <v-ons-button modifier="outline perflarge" @click="showFlashDeeplink">
              {{ flashHeader.ok }}
            </v-ons-button>
          </footer>
        </div>

        <div v-else-if="newRecolte" class="content--perfhome__quiz">
          <header>
            <span>{{ newRecolte }}</span>
          </header>
          <section>
            <div>
              <img src="../assets/imgs/mascot@2x.png">
            </div>
            <p>
              <b>Bonjour {{ user.prenom }},</b>
              Il est temps de préparer la nouvelle campagne&nbsp;!
            </p>
          </section>
          <footer>
            <v-ons-button modifier="outline perflarge" @click="changeRecolte">
              Créer ma récolte {{ newRecolte }}
            </v-ons-button>
          </footer>
        </div>

        <div v-else-if="isMajDispo" class="content--perfhome__quiz">
          <header>
            <span>AIDE</span>
          </header>
          <section>
            <div>
              <img src="../assets/imgs/mascot@2x.png">
            </div>
            <p>
              <b>Bonjour {{ user.prenom }},</b>
              Une nouvelle version de l'appli est disponible&nbsp;!
            </p>
          </section>
          <footer>
            <v-ons-button modifier="outline perflarge" @click="$redirectToStore()">
              Mettre à jour Perfarmer
            </v-ons-button>
          </footer>
        </div>

        <div v-else-if="showPush" class="content--perfhome__msg">
          <section>
            <div>
              <img src="../assets/imgs/mascot@2x.png">
            </div>
            <p>
              <span>
                <a href="#" @click="$emit('show-params', 'push')">Cliquez-ici</a> pour activer les notifications sur
                {{ showPush == 'negoce' ? 'les prix de votre OS' : 'vos alertes' }}.
              </span>
            </p>
          </section>
        </div>

        <!--
        <div class="content--perfhome__quiz">
          <header>
            <span>QUIZ</span>
          </header>
          <section>
            <div>
              <img src="../assets/imgs/mascot@2x.png">
            </div>
            <p>
              <b>Bonjour {{ user.prenom }},</b>
              C'est parti pour le récap de la semaine&nbsp;?
            </p>
          </section>
          <footer>
            <v-ons-button modifier="outline perflarge">
              Faire le quiz
            </v-ons-button>
          </footer>
        </div>
        -->

        <v-ons-list v-for="(strategieItem, strategieIndex) in listStrategie"
                    :key="strategieIndex + '-' + strategieItem.refCulture + '-' + strategieItem.refDestination"
                    modifier="noborder perflist">

          <v-ons-list-item key="bg" modifier="perfcultbg nodivider chevron" :style="{'background-image': strategieItem.background}"
                           @click="showNegocePrix(strategieIndex)" :id="'list-item-' + strategieIndex + '-bg'">

            <div class="center">
              <span class="list-item__title">
                {{ strategieItem.title }}
                <img v-if="strategieItem.isBio" src="../assets/imgs/bio_carre@2x.png">
              </span>
              <span v-if="strategieItem.subtitle" class="list-item__subtitle">
                {{ strategieItem.subtitle }}
              </span>
            </div>

          </v-ons-list-item>

          <template v-if="strategieItem.coursJour">
            <v-ons-list-item key="cours"
                            :modifier="'perfcours nodivider' + (strategieItem.coursJour.isTappable ? ' chevron' : '')"
                            :expandable="strategieItem.coursJour.isExpandable" :tappable="strategieItem.coursJour.isTappable"
                            :expanded.sync="listExpanded.euronext[strategieIndex + '-' + strategieItem.refCulture + '-' + strategieItem.refDestination]"
                            @click="strategieItem.coursJour.isExpandable ? null : showCours(strategieIndex)">

              <div class="center">
                <template v-if="strategieItem.coursJour.isExpandable && ! isExpanded('euronext', strategieIndex) && ! strategieItem.coursJour.default.isExpire">
                  Euronext
                </template>
                <template v-else-if="strategieItem.coursJour.isExpandable && isExpanded('euronext', strategieIndex)">
                  Euronext - {{ getCoursDate(strategieItem.coursJour.date, false, live.date, now) }}
                </template>
                <template v-else>
                  {{ strategieItem.coursJour.label }}
                </template>
              </div>
              <div class="right">
                <span v-if="strategieItem.coursJour.isExpandable && ! isExpanded('euronext', strategieIndex) && ! strategieItem.coursJour.default.isExpire"
                          class="label-grey">
                  Voir les échéances
                </span>
                <template v-else-if="! (strategieItem.coursJour.isExpandable && isExpanded('euronext', strategieIndex))">
                  <template v-if="strategieItem.coursJour.default">
                    <v-ons-icon v-if="strategieItem.coursJour.isTappable" icon="fa-chart-line"></v-ons-icon>
                    <div v-if="strategieItem.coursJour.default.isExpire" class="label-grey">
                      {{ strategieItem.coursJour.isEuronext ? 'Éch. expirée' : 'Expiré' }}
                    </div>
                    <div v-else-if="strategieItem.coursJour.default.isLiveDiff" class="badge"
                          :class="{ 'badge-vert': strategieItem.coursJour.default.diff > 0, 'badge-rouge': strategieItem.coursJour.default.diff < 0 }">
                      {{ formatCoursDiff(strategieItem.coursJour.default.diff) }}
                    </div>
                    <div>
                      {{strategieItem.coursJour.default.cours.toLocaleString('fr', { minimumFractionDigits: 2 })}}
                    </div>
                  </template>
                  <div v-else-if="strategieItem.coursJour.isExpire" class="label-grey">
                    {{ strategieItem.coursJour.isEuronext ? 'Éch. expirée' : 'Expiré' }}
                  </div>
                  <span v-else class="label-grey">
                    Cours non disponible
                  </span>
                </template>
                <span v-if="strategieItem.coursJour.isExpandable" class="list-item__expand-chevron"></span>
              </div>

              <div v-if="strategieItem.coursJour.isExpandable" class="expandable-content">
                <v-ons-list modifier="noborder nopadding">
                  <v-ons-list-item v-for="(coursItem, echeance) in strategieItem.coursJour.list"
                                  :key="echeance" modifier="perfcours chevron" tappable
                                  @click="showCours(strategieIndex, echeance)">
                    <div class="center">
                      {{ getLabelEcheance(echeance) }}
                    </div>
                    <div class="right">
                      <template v-if="coursItem">
                        <div v-if="coursItem.isExpire" class="label-grey">
                          Éch. expirée
                        </div>
                        <div v-else-if="coursItem.isLiveDiff" class="badge"
                            :class="{ 'badge-vert': coursItem.diff > 0, 'badge-rouge': coursItem.diff < 0 }">
                          {{ formatCoursDiff(coursItem.diff) }}
                        </div>
                        <div>
                          {{ coursItem.cours.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
                        </div>
                      </template>
                      <span v-else class="label-grey">
                        Cours non disponible
                      </span>
                    </div>
                  </v-ons-list-item>
                </v-ons-list>
              </div>

            </v-ons-list-item>
            
            <v-ons-list-item v-if="strategieItem.coursJour.isExpandable && ! strategieItem.coursJour.default.isExpire" key="default"
                            modifier="perfcours chevron expandpreview" tappable @click="showCours(strategieIndex)">
              <div class="center">
                {{ strategieItem.coursJour.label }}
              </div>
              <div class="right">
                <v-ons-icon icon="fa-chart-line"></v-ons-icon>
                <div v-if="strategieItem.coursJour.default.isLiveDiff" class="badge"
                      :class="{ 'badge-vert': strategieItem.coursJour.default.diff > 0, 'badge-rouge': strategieItem.coursJour.default.diff < 0 }">
                  {{ formatCoursDiff(strategieItem.coursJour.default.diff) }}
                </div>
                <div>
                  {{strategieItem.coursJour.default.cours.toLocaleString('fr', { minimumFractionDigits: 2 })}}
                </div>
              </div>
            </v-ons-list-item>

          </template>

          <v-ons-list-item v-for="(negoceItem, negoceIndex) in strategieItem.negoce" :key="'negoce-' + negoceItem.id + (negoceItem.list.length ? '-exp' : '')"
                           :modifier="'perfcours nodivider' + (negoceItem.list.length ? '' : ' chevron')"
                           :expandable="negoceItem.list.length > 0" :tappable="! negoceItem.list.length"
                           :expanded.sync="listExpanded.prix[negoceIndex][strategieIndex + '-' + strategieItem.refCulture + '-' + strategieItem.refDestination]"
                           @click="negoceItem.list.length ? null : showNegocePrix(strategieIndex, negoceItem.id)">

            <div class="center">
              {{ negoceItem.label }}
              <template v-if="negoceItem.list.length && isExpanded('prix', strategieIndex, negoceIndex)">
                {{ negoceItem.date ? ' - ' + negoceItem.date : '' }}
              </template>
            </div>
            <div class="right">
              <template v-if="! (negoceItem.list.length && isExpanded('prix', strategieIndex, negoceIndex))">
                <span v-if="negoceItem.list.length > 1" class="label-grey">
                  Voir les prix
                </span>
                <template v-else-if="negoceItem.list.length == 1 && negoceItem.list[0].cours">
                  <div v-if="negoceItem.list[0].is_flash" class="badge badge-jaune">
                    FLASH
                  </div>
                  <div v-else-if="negoceItem.list[0].var !== undefined" class="badge"
                        :class="{ 'badge-vert': negoceItem.list[0].var > 0, 'badge-rouge': negoceItem.list[0].var < 0 }">
                    {{ formatCoursDiff(negoceItem.list[0].var) }}
                  </div>
                  <div>
                    {{ negoceItem.list[0].cours.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
                  </div>
                </template>
                <span v-else class="label-grey">
                  {{ negoceItem.non_dispo ? negoceItem.non_dispo : 'Non disponible' }}
                </span>
              </template>
              <span v-if="negoceItem.list.length > 0" class="list-item__expand-chevron"></span>
            </div>

            <div v-if="negoceItem.list.length" class="expandable-content">
              <v-ons-list modifier="noborder nopadding">
                <v-ons-list-item v-for="prixItem in negoceItem.list" :key="prixItem.id" modifier="perfcours chevron"
                                 @click="showNegocePrix(strategieIndex, negoceItem.id, prixItem.id)" tappable>
                  <div class="center">
                    {{ prixItem.label.replace(/([^•]) ([^•])/g, '$1&nbsp;$2') }}
                    {{ prixItem.suffix }}
                  </div>
                  <div v-if="prixItem.cours !== null" class="right">
                    <template v-if="prixItem.cours !== ''">
                      <div v-if="prixItem.is_flash" class="badge badge-jaune">
                        FLASH
                      </div>
                      <div v-else-if="prixItem.var !== undefined" class="badge"
                            :class="{ 'badge-vert': prixItem.var > 0, 'badge-rouge': prixItem.var < 0 }">
                        {{ formatCoursDiff(prixItem.var) }}
                      </div>
                      <div>
                        {{ prixItem.cours.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
                      </div>
                    </template>
                    <span v-else class="label-grey">
                      {{ negoceItem.non_dispo ? negoceItem.non_dispo : 'Non disponible' }}
                    </span>
                  </div>
                </v-ons-list-item>
                <v-ons-list-item v-if="negoceItem.is_config" modifier="perfbutton">
                  <v-ons-button @click="configNegoce(negoceItem.id, strategieItem.refCulture, strategieItem.refDestination)" modifier="quiet">
                    Modifier mes prix
                  </v-ons-button>
                </v-ons-list-item>
              </v-ons-list>
            </div>

          </v-ons-list-item>

          <v-ons-list-item v-if="! strategieItem.negoce.length" key="negoce" modifier="perfcours nodivider chevron"
                           @click="showNegocePrix(strategieIndex)" tappable>
            <div class="center">
              Prix OS
            </div>
            <div class="right">
              <span class="label-grey">
                Ajouter
              </span>
            </div>
          </v-ons-list-item>

          <v-ons-list-item v-if="strategieItem.alerte.isShow" key="alerte" modifier="perfalerte nodivider chevron"
                           @click="showAlerte(strategieIndex)" tappable>
            <div class="center">
              {{ strategieItem.alerte.label }}
            </div>
            <div class="right">
              <div v-if="strategieItem.alerte.value">
                {{ strategieItem.alerte.value }}&nbsp;€/t
              </div>
              <span v-else class="label-grey">
                Définir
              </span>
            </div>
          </v-ons-list-item>

          <v-ons-list-item v-if="strategieItem.negoce.length" key="cta" modifier="perfbutton">
            <v-ons-button modifier="outline perflarge" @click="showVente(strategieIndex)">
              {{ negoce.length > 1 ? 'Vendre mon ' + strategieItem.title : 'Vendre à ' + strategieItem.negoce[0].label }}
            </v-ons-button>
            <app-call-negoce :negoce-infos="strategieItem.negoce[0]" track-infos="home prix" :is-appro="false"></app-call-negoce>
          </v-ons-list-item>

        </v-ons-list>

        <v-ons-list v-for="(approItem, approIndex) in listAppro" :key="approIndex + '-' + approItem.refAppro"
                    modifier="noborder perflist">

          <v-ons-list-item key="bg" modifier="perfcultbg nodivider chevron" :style="{'background-image': approItem.background}"
                           @click="showNegoceAppro(approIndex)">
            <div class="center">
              <span class="list-item__title">
                {{ approItem.title }}
              </span>
            </div>
          </v-ons-list-item>

          <v-ons-list-item v-for="(negoceItem, negoceIndex) in approItem.negoce" :key="'negoce-' + negoceItem.id + (negoceItem.list.length ? '-exp' : '')"
                            :modifier="'perfcours nodivider' + (negoceItem.list.length ? '' : ' chevron')"
                            :expandable="negoceItem.list.length > 0" :tappable="! negoceItem.list.length"
                            :expanded.sync="listExpanded.appro[negoceIndex][approIndex + '-' + approItem.refAppro]"
                            @click="negoceItem.list.length ? null : showNegoceAppro(approIndex, negoceItem.id)">

            <div class="center">
              {{ negoceItem.label_appro ? negoceItem.label_appro : negoceItem.label }}
              <template v-if="negoceItem.list.length && isExpanded('appro', approIndex, negoceIndex)">
                {{ negoceItem.date ? ' - ' + negoceItem.date : '' }}
              </template>
            </div>
            <div class="right">
              <template v-if="! (negoceItem.list.length && isExpanded('appro', approIndex, negoceIndex))">
                <span v-if="negoceItem.list.length > 1" class="label-grey">
                  Voir les prix
                </span>
                <template v-else-if="negoceItem.list.length == 1 && negoceItem.list[0].cours">
                  <div v-if="negoceItem.list[0].is_flash" class="badge badge-jaune">
                    FLASH
                  </div>
                  <div v-else-if="negoceItem.list[0].var !== undefined" class="badge"
                        :class="{ 'badge-vert': negoceItem.list[0].var < 0, 'badge-rouge': negoceItem.list[0].var > 0 }">
                    {{ formatCoursDiff(negoceItem.list[0].var) }}
                  </div>
                  <div>
                    {{ negoceItem.list[0].cours.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
                  </div>
                </template>
                <span v-else class="label-grey">
                  {{ negoceItem.non_dispo ? negoceItem.non_dispo : 'Non disponible' }}
                </span>
              </template>
              <span v-if="negoceItem.list.length > 0" class="list-item__expand-chevron"></span>
            </div>

            <div v-if="negoceItem.list.length" class="expandable-content">
              <v-ons-list modifier="noborder nopadding">
                <v-ons-list-item v-for="prixItem in negoceItem.list" :key="prixItem.id" modifier="perfcours chevron"
                                 @click="showNegoceAppro(approIndex, negoceItem.id, prixItem.id)" tappable>
                  <div class="center">
                    {{ prixItem.label.replace(/([^•]) ([^•])/g, '$1&nbsp;$2') }}
                    {{ prixItem.suffix }}
                  </div>
                  <div class="right">
                    <template v-if="prixItem.cours">
                      <div v-if="prixItem.is_flash" class="badge badge-jaune">
                        FLASH
                      </div>
                      <div v-else-if="prixItem.var !== undefined" class="badge"
                            :class="{ 'badge-vert': prixItem.var < 0, 'badge-rouge': prixItem.var > 0 }">
                        {{ formatCoursDiff(prixItem.var) }}
                      </div>
                      <div>
                        {{ prixItem.cours.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
                      </div>
                    </template>
                    <span v-else class="label-grey">
                      {{ negoceItem.non_dispo ? negoceItem.non_dispo : 'Non disponible' }}
                    </span>
                  </div>
                </v-ons-list-item>
              </v-ons-list>
            </div>

          </v-ons-list-item>

          <v-ons-list-item key="cta" modifier="perfbutton">
            <!--
            <v-ons-button modifier="outline perflarge" @click="showAchat(approIndex)">
              {{ negoce.length > 1 ? 'Acheter mon ' + approItem.title : 'Acheter à ' + approItem.negoce[0].label }}
            </v-ons-button>
            -->
            <app-call-negoce :negoce-infos="approItem.negoce[0]" track-infos="home appro" :is-appro="true"></app-call-negoce>
          </v-ons-list-item>

        </v-ons-list>

      </div>

    </div>

    <v-ons-popover ref="missingConfigPopover" modifier="perfarmer" :visible.sync="missingConfig.isShow" :target="missingConfig.target"
                   direction="down" @postshow="missingConfigPostShow" cancelable>
      <template v-if="missingConfig.count < 2">
        <h2>Encore un petit effort&nbsp;:)</h2>
        <p>Quels prix souhaitez-vous suivre pour votre «{{ missingConfig.label }}»&nbsp;?</p>
      </template>
      <template v-else>
        <h2>Et pour votre {{ missingConfig.label }}&nbsp;?</h2>
        <p>Quels prix souhaitez-vous suivre&nbsp;?</p>
      </template>
      <v-ons-button modifier="large--cta perflarge"
                    @click="configNegoce(missingConfigInfos.negoceId, missingConfigInfos.refCulture, missingConfigInfos.refDestination)">
        Sélectionner mes prix
      </v-ons-button>
    </v-ons-popover>

    <v-ons-action-sheet v-if="listStrategie[buttonsVente.strategieIndex] && listStrategie[buttonsVente.strategieIndex].negoce.length"
                        :modifier="$mdModifier" :visible.sync="buttonsVente.isShow" cancelable
                        title="Sélectionnez une action">
      <v-ons-action-sheet-button v-for="negoceItem in listStrategie[buttonsVente.strategieIndex].negoce" :key="negoceItem.id"
                                 :modifier="$mdModifier" @click="showVente(buttonsVente.strategieIndex, negoceItem.id)">
        Vendre à {{ negoceItem.label }}
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button v-if="! $md" @click="buttonsVente.isShow = false">Fermer
      </v-ons-action-sheet-button>
    </v-ons-action-sheet>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppPullHook from '../partials/PullHook.vue';
import AppCallNegoce from '../partials/CallNegoce.vue';

import AppOngletNegoce from './OngletNegoce.vue';
import AppOngletCours from './OngletCours.vue';
import AppOngletAlerte from './OngletAlerte.vue';
import AppNegoceConfig from './NegoceConfig.vue';
import AppVenteDemande from './VenteDemande.vue';
import AppClientSelect from './ClientSelect.vue';
import AppAlerteSeuil from './AlerteSeuil.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppPullHook, AppCallNegoce },
  props: ['pageStack', 'initInfos'],
  data() {
    return {
      missingConfig: {
        isShow: false,
        target: '',
        label: '',
        count: 0
      },
      buttonsVente: {
        isShow: false,
        strategieIndex: -1
      },
      listExpanded: {
        euronext: {},
        prix: [],
        appro: []
      },
      isNoteShort: true,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    clientConnect() {
      return this.state.client;
    },
    clientInfos() {
      if(this.isTech && this.clientConnect.id){
        return this.getClientInfosTech(this.data.negoce.clients, this.clientConnect.id);
      }
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    isSync() {
      return this.state.isSync;
    },
    live() {
      return this.data.live;
    },
    now() {
      return this.data.now;
    },
    referentiel() {
      return this.data.referentiel;
    },
    cours() {
      return this.data.cours;
    },
    negoce() {
      return this.getNegoceAcces(this.data.negoce.list);
    },
    isTech() {
      return this.negoce[0] && this.negoce[0].is_tech;
    },
    flashHeader() {
      var negoceList = this.negoce.map(item => { return item.id });
      if(this.data.negoce.flash && negoceList.includes(this.data.negoce.flash.id)){
        var header = this.data.negoce.flash;
        var headerType = 'FLASH';
      } else if(this.data.negoce.note && negoceList.includes(this.data.negoce.note.id)){
        var header = this.data.negoce.note;
        var headerType = 'NOTE';
      } else {
        return null;
      }
      var flashHeader = {
        type: headerType,
        img: header.img,
        title: header.title,
        msg: this.evalDate(header.msg),
        ok: header.ok,
        deeplink: header.deeplink
      };
      if(headerType == 'NOTE'){
        var msgShort = [];
        var textLength = 0;
        var maxLength = 140;
        for (let i = 0; i < header.msg.length; i++) {
          const ligne = header.msg[i];
          textLength += ligne.length;
          if(textLength > maxLength){
            flashHeader.isShort = true;
            msgShort.push(ligne.substring(0, ligne.length - (textLength - maxLength)));
            break;
          } else {
            msgShort.push(ligne);
          }
        }
        if(this.isNoteShort){
          flashHeader.msg = msgShort;
        }
      }
      return flashHeader;
    },
    newRecolte() {
      var listCampagne = [this.user.campagne];
      var idUser = this.user.id.toString();
      idUser = idUser.substring(0, idUser.length - 4);
      var multi = this.state.multi;
      for (const id in multi) {
        var idMulti = id.toString();
        idMulti = idMulti.substring(0, idMulti.length - 4);
        if(idMulti != idUser){
          continue;
        }
        const multiUser = multi[id];
        if(multiUser.nbCult){
          listCampagne.push(multiUser.campagne);
        }
      }
      if(! listCampagne.includes(this.cours.campagne)){
        return this.cours.campagne;
      }
      for (let i = 0; i < this.negoce.length; i++) {
        var negoceItem = this.negoce[i];
        for (const campagne in negoceItem.prix) {
          const campagneInt = parseInt(campagne);
          if(campagneInt > this.cours.campagne && ! listCampagne.includes(campagneInt)){
            return campagneInt;
          }
        }
      }
      return '';
    },
    isMajDispo() {
      var appVersion = this.$appVersion.split('.');
      appVersion = parseInt(appVersion[0])*10000 + parseInt(appVersion[1])*100 + parseInt(appVersion[2]);
      return this.referentiel.app_version > appVersion;
    },
    showPush() {
      if (this.state.push_ok != null && !this.state.push_ok) {
        if (this.negoce.length) {
          return 'negoce';
        }
        for (const refCulture in this.user.ventes) {
          for (const refDestination in this.user.ventes[refCulture]) {
            if (this.user.ventes[refCulture][refDestination].objectif) {
              return 'alerte'
            }
          }
        }
      }
      return false;
    },
    listStrategie() {
      var list = [];

      for (const refCult in this.user.ventes) {
        for (const refDest in this.user.ventes[refCult]) {
          var strategie = this.user.ventes[refCult][refDest];

          var listPrixNegoce = [];
          var isPrix = false;
          var isPrixCours = false;
          var echeancePrix = '';
          if (! this.missingConfigInfos) {
            listPrixNegoce = this.getPrixNegoce(this.negoce, refCult, refDest, this.campagne);
            for (let i = 0; i < listPrixNegoce.length; i++) {
              var negoceItem = listPrixNegoce[i];
              if(this.clientInfos && this.clientInfos.config){
                negoceItem.list = this.filterListPrix(negoceItem.list, this.clientInfos.config)
              } else if(negoceItem.prix_max && negoceItem.prix_max.config){
                negoceItem.list = this.filterListPrix(negoceItem.list, negoceItem.prix_max.config)
              }
              if(negoceItem.prix_max){
                negoceItem.list = this.maxListPrix(negoceItem.list);
              }
              for (let j = 0; j < negoceItem.list.length; j++) {
                var prixItem = negoceItem.list[j];
                if(prixItem.echeance){
                  if(echeancePrix){
                    if(! isPrixCours && prixItem.cours){ // 1ere echeance avec un prix
                      echeancePrix = prixItem.echeance;
                    } else if(! (isPrixCours && ! prixItem.cours)) { // sauf si sans prix et déjà un prix
                      echeancePrix = Math.min(prixItem.echeance, echeancePrix);
                    }
                  } else {
                    echeancePrix = prixItem.echeance;
                  }
                }
                if(prixItem.cours){
                  isPrixCours = true;
                }
                isPrix = true;
              }
            }
          }
          var isPrixNegoce = this.missingConfigInfos || listPrixNegoce.length;
          echeancePrix = echeancePrix.toString();

          if (strategie.contrat === undefined) {
            var coursName = this.referentiel.cultures[refCult].destinations[refDest].cours;
            var echeanceCurrent = this.cours[coursName].current;
            var echeanceList = this.getEcheanceList(coursName, this.campagne);
            var echeanceDefault = this.getEcheanceDefault(this.campagne, echeanceCurrent, echeanceList);
            var coursJour = {
              list: this.getCoursJour(coursName, this.cours[coursName], this.live, echeanceList, echeanceDefault, true)
            };
            if(strategie.objectif && ! strategie.negoce){
              if (strategie.echeance) {
                echeanceDefault = strategie.echeance;
              }
            } else if (echeancePrix && echeanceList.indexOf(echeancePrix) >= echeanceList.indexOf(echeanceDefault)){
              echeanceDefault = echeancePrix;
            }
            coursJour.default = coursJour.list[echeanceDefault];
            coursJour.isExpire = echeanceDefault < echeanceCurrent;
            coursJour.label = this.referentiel.cours[coursName].libelle_cours;
            coursJour.suffix = this.getCoursSuffix(coursName);
            coursJour.isExpandable = false;
            coursJour.isTappable = false;
            if (echeanceList.length) {
              coursJour.isEuronext = true;
              coursJour.isExpandable = coursJour.default ? true : false;
              if(coursJour.default && ! coursJour.isExpire){
                coursJour.label = this.getLabelEcheance(echeanceDefault);
              } else {
                coursJour.label += ' - ' + this.getLabelEcheance(echeanceDefault);
              }
              for (const echeance in coursJour.list) {
                if (coursJour.list[echeance]) {
                  coursJour.date = coursJour.list[echeance].date;
                }
              }
            } else if (isPrixNegoce) {
              coursJour = null; // Pas de cours physique si prix OS
            } else {
              coursJour.isTappable = coursJour.default ? true : false;
            }
          } else if (! isPrixNegoce) {
            continue; // Affiché uniquement si cours ou si prix OS (même "Non disponible" par défaut)
          } else {
            coursJour = null;
          }

          var alerte = strategie.objectif;
          if (!strategie.negoce) {
            alerte = this.getCoursFromEffectif(
              strategie.objectif,
              this.referentiel.cultures[refCult].destinations[refDest],
              strategie.diff
            );
          }

          if(this.isTech){
            var clientConnectInfos = this.getClientConnectInfos(this.clientConnect.id, strategie);
            if(clientConnectInfos.surface === 0){
              continue;
            }
          }

          var title = this.getCultLabel(refCult, refDest).split(' - ');
          list.push({
            refCulture: refCult,
            refDestination: refDest,
            background: this.$getCultAsset(refCult, refDest, 'bg'),
            isBio: this.user.seuil.cours[refCult][refDest].is_bio,
            title: title.shift(),
            subtitle: title.join(' - '),
            coursJour: coursJour,
            negoce: listPrixNegoce,
            alerte: {
              value: this.isTech ? clientConnectInfos.objectif : alerte,
              isShow: (coursJour && !coursJour.isExpire) || isPrix,
              label: 'Mon alerte ' + (!this.isTech && alerte && !strategie.negoce && coursJour ? coursJour.suffix : '')
            }
          });
        }
      }
      this.sortCultList(list);
      return list;
    },
    listAppro() {
      var list = [];
      for (const refAppro in this.referentiel.libelles.appros) {
        var listPrixNegoce = this.getPrixNegoce(this.negoce, 'appros', refAppro);
        var nbPrixNegoce = listPrixNegoce.reduce(function (sum, negoceItem){ return sum + negoceItem.list.length; }, 0);
        if(nbPrixNegoce){
          list.push({
            refAppro: refAppro,
            background: this.$getCultAsset('appro', refAppro, 'bg'),
            title: this.referentiel.libelles.appros[refAppro],
            negoce: listPrixNegoce,
          });
        }
      }
      return list;
    },
    missingConfigInfos() {
      return this.getMissingConfig(this.negoce);
    }
  },
  watch: {
    'missingConfig.isShow'(value) {
      if (value) {
        this.missingConfig.count++;
      } else {
        this.$el.querySelector('.content--perfhome').style.marginBottom = 0;
      }
    },
    listStrategie() {
      this.setListExpanded(true);
    },
    negoce() {
      this.setListExpanded(true);
    }
  },
  methods: {
    showPage() {
      if (this.state.push_ok == null && window.FirebasePlugin) {
        window.FirebasePlugin.hasPermission(function (hasPermission) {
          store.state.push_ok = hasPermission;
        });
      }
      if (this.missingConfigInfos) {
        for (let i = 0; i < this.listStrategie.length; i++) {
          var strategieItem = this.listStrategie[i];
          if (strategieItem.refCulture == this.missingConfigInfos.refCulture
          && strategieItem.refDestination == this.missingConfigInfos.refDestination) {
            this.missingConfig.target = '#list-item-' + i + '-bg';
            this.missingConfig.label = strategieItem.title;
            break;
          }
        }
        var pageHeight = this.$el.offsetHeight;
        var initScroll = this.$el.querySelector(this.missingConfig.target).offsetTop;
        var elParent = this.$el.querySelector('.content--perfhome');
        // add margin-bottom si bas de page
        if (elParent.offsetHeight < pageHeight + initScroll) {
          elParent.style.marginBottom = (pageHeight + initScroll - elParent.offsetHeight) + 'px';
        }
        this.$el.scrollTop = initScroll;
        this.missingConfig.isShow = true;
      }
      // debug console.log('update from show');
      this.$emit('update-if-needed');
    },
    missingConfigPostShow() {
      var pageHeight = this.$el.offsetHeight;
      var popover = this.$refs.missingConfigPopover.$el.querySelector('.popover');
      if (popover.offsetTop + popover.offsetHeight > pageHeight) {
        popover.style.top = 'auto';
        popover.style.bottom = 0;
      }
      /*
      var popoverMask = this.$refs.missingConfigPopover.$el.querySelector('.popover-mask');
      var target = this.$el.querySelector(this.missingConfig.target);
      popoverMask.style.top = (this.$el.getBoundingClientRect().top + target.offsetHeight) + 'px';
      */
    },
    showNegocePrix(strategieIndex, negoceId, prixId) {
      var strategieItem = this.listStrategie[strategieIndex];
      if(! negoceId){
        // TODO action sheet
        // if(strategieItem.negoce.length > 1){
        if(strategieItem.negoce.length){
          negoceId = strategieItem.negoce[0].id;
        }
      }
      this.pageStack.push({
        extends: AppOngletNegoce,
        data() {
          return {
            negoceId: negoceId,
            refCulture: strategieItem.refCulture,
            refDestination: strategieItem.refDestination,
            prixId: prixId
          }
        }
      });
    },
    showNegoceAppro(approIndex, negoceId, prixId) {
      var approItem = this.listAppro[approIndex];
      if(! negoceId){
        // TODO action sheet
        // if(approItem.negoce.length > 1){
        if(approItem.negoce.length){
          negoceId = approItem.negoce[0].id;
        }
      }
      this.pageStack.push({
        extends: AppOngletNegoce,
        data() {
          return {
            negoceId: negoceId,
            refCulture: 'appros',
            refDestination: approItem.refAppro,
            prixId: prixId
          }
        }
      });
    },
    showCours(strategieIndex, echeance){
      var strategieItem = this.listStrategie[strategieIndex];
      if(! strategieItem.coursJour.default){
        return;
      }
      this.pageStack.push({
        extends: AppOngletCours,
        data() {
          return {
            refCulture: strategieItem.refCulture,
            refDestination: strategieItem.refDestination,
            echeanceInit: echeance
          }
        },
        onsNavigatorOptions: {
          animation: this.$md ? 'fade' : 'lift' // pour éviter le "swipe to pop" d'iOS
        }
      });
    },
    showAlerte(strategieIndex){
      var strategieItem = this.listStrategie[strategieIndex];
      if(this.isTech){
        if(this.clientConnect.id){
          var clientId = this.clientConnect.id;
          this.pageStack.push({
            extends: AppAlerteSeuil,
            data() {
              return {
                refCulture: strategieItem.refCulture,
                refDestination: strategieItem.refDestination,
                client: clientId
              }
            }
          });
        } else {
          this.pageStack.push({
            extends: AppClientSelect,
            data() {
              return {
                workflow: 'alerte',
                refCulture: strategieItem.refCulture,
                refDestination: strategieItem.refDestination
              }
            }
          });
        }
      } else if(strategieItem.alerte.value){
        this.pageStack.push({
          extends: AppOngletAlerte,
          data() {
            return {
              refCulture: strategieItem.refCulture,
              refDestination: strategieItem.refDestination
            }
          }
        });
      } else {
        this.pageStack.push({
          extends: AppAlerteSeuil,
          data() {
            return {
              refCulture: strategieItem.refCulture,
              refDestination: strategieItem.refDestination
            }
          }
        });
      }
    },
    setListExpanded(isReset) {
      var listExpanded = {
        euronext: {},
        prix: [],
        appro: []
      };
      for (let i = 0; i < this.negoce.length; i++) {
        listExpanded.prix[i] = {};
        listExpanded.appro[i] = {};
      }
      for (let i = 0; i < this.listStrategie.length; i++) {
        var strategieItem = this.listStrategie[i];
        var key = i + '-' + strategieItem.refCulture + '-' + strategieItem.refDestination;
        listExpanded.euronext[key] = false;
        for (let negoceIndex = 0; negoceIndex < listExpanded.prix.length; negoceIndex++) {
          listExpanded.prix[negoceIndex][key] = false;
          // déjà ouvert
          if(this.listExpanded.prix[negoceIndex]
          && this.listExpanded.prix[negoceIndex][key]){
            listExpanded.prix[negoceIndex][key] = true;
          }
          // sauf si non expandable
          if(! (strategieItem.negoce[negoceIndex]
          &&    strategieItem.negoce[negoceIndex].list.length)){
            listExpanded.prix[negoceIndex][key] = false;
          }
        }
      }
      for (let i = 0; i < this.listAppro.length; i++) {
        var approItem = this.listAppro[i];
        var key = i + '-' + approItem.refAppro;
        for (let negoceIndex = 0; negoceIndex < listExpanded.appro.length; negoceIndex++) {
          listExpanded.appro[negoceIndex][key] = false;
          // déjà ouvert
          if(this.listExpanded.appro[negoceIndex]
          && this.listExpanded.appro[negoceIndex][key]){
            listExpanded.appro[negoceIndex][key] = true;
          }
          // sauf si non expandable
          if(! (approItem.negoce[negoceIndex]
          &&    approItem.negoce[negoceIndex].list.length)){
            listExpanded.appro[negoceIndex][key] = false;
          }
        }
      }
      this.listExpanded = listExpanded;
      if(isReset){
        this.$nextTick(function(){
          for (let i = 0; i < this.listStrategie.length; i++) {
            var strategieItem = this.listStrategie[i];
            var key = i + '-' + strategieItem.refCulture + '-' + strategieItem.refDestination;
            for (let negoceIndex = 0; negoceIndex < this.listExpanded.prix.length; negoceIndex++) {
              if(! negoceIndex
              && (strategieItem.negoce[negoceIndex]
              &&  strategieItem.negoce[negoceIndex].list.length
              &&  strategieItem.negoce[negoceIndex].list.length < 15)){
                this.$set(this.listExpanded.prix[negoceIndex], key, true);
              }
            }
          }
          for (let i = 0; i < this.listAppro.length; i++) {
            var approItem = this.listAppro[i];
            var key = i + '-' + approItem.refAppro;
            for (let negoceIndex = 0; negoceIndex < this.listExpanded.appro.length; negoceIndex++) {
              if(! negoceIndex
              && (approItem.negoce[negoceIndex]
              &&  approItem.negoce[negoceIndex].list.length
              &&  approItem.negoce[negoceIndex].list.length < 15)){
                this.$set(this.listExpanded.appro[negoceIndex], key, true);
              }
            }
          }
        });
      }
    },
    isExpanded(type, index, negoceIndex) {
      if(type == 'appro'){
        var approItem = this.listAppro[index];
        var key = index + '-' + approItem.refAppro;
        return this.listExpanded.appro[negoceIndex][key];
      } else {
        var strategieItem = this.listStrategie[index];
        var key = index + '-' + strategieItem.refCulture + '-' + strategieItem.refDestination;
        if(type == 'euronext'){
          return this.listExpanded.euronext[key];
        } else {
          return this.listExpanded.prix[negoceIndex][key];
        }
      }
    },
    showVente(strategieIndex, negoceId, prixId) {
      var strategieItem = this.listStrategie[strategieIndex];
      if(! strategieItem.negoce.length){
        return;
      }
      if(this.isTech){
        if(this.clientConnect.id){
          negoceId = this.clientConnect.negoceId;
          var clientId = this.clientConnect.id;
          this.pageStack.push({
            extends: AppVenteDemande,
            data() {
              return {
                negoceId: negoceId,
                refCulture: strategieItem.refCulture,
                refDestination: strategieItem.refDestination,
                vente: {
                  client: clientId
                }
              }
            }
          });
        } else {
          this.pageStack.push({
            extends: AppClientSelect,
            data() {
              return {
                workflow: 'vente',
                refCulture: strategieItem.refCulture,
                refDestination: strategieItem.refDestination
              }
            }
          });
        }
      } else if (strategieItem.negoce.length > 1 && ! negoceId) {
        this.buttonsVente = {
          isShow: true,
          strategieIndex: strategieIndex
        };
      } else {
        if (! negoceId) {
          negoceId = strategieItem.negoce[0].id;
        }
        this.buttonsVente.isShow = false;
        this.pageStack.push({
          extends: AppVenteDemande,
          data() {
            return {
              negoceId: negoceId,
              refCulture: strategieItem.refCulture,
              refDestination: strategieItem.refDestination,
              vente: {
                id_prix: prixId !== undefined ? prixId : ''
              }
            }
          }
        });
        this.sendTrackEvent('negoce click ' + negoceId + ' home ' + strategieItem.refCulture + ' ' + strategieItem.refDestination);
      }
    },
    configNegoce(negoceId, refCulture, refDestination) {
      this.missingConfig.isShow = false;
      this.pageStack.push({
        extends: AppNegoceConfig,
        data() {
          return {
            negoceId: negoceId,
            refCulture: refCulture,
            refDestination: refDestination
          }
        }
      });
    },
    changeRecolte() {
      store.state.onboarding.step = 2;
      this.ionicStorage.set('onboarding', this.state.onboarding);
      this.$emit('change-recolte', { 
        idMulti: Math.floor(parseInt(this.user.id) / 100).toString() + (this.newRecolte % 100).toString()
      });
    },
    showFlashDeeplink() {
      var path = this.flashHeader.deeplink.split('/');
      path.shift(); // root /
      var pathItem = path.shift(); // app/
      if(pathItem == 'tel'){
        pathItem = path.shift();
        this.$callTel(pathItem);
      } else {
        pathItem = path.shift();
        var idMulti = Math.floor(parseInt(this.user.id) / 100).toString() + pathItem.toString();
        this.$emit('change-multi', {
          idMulti: idMulti,
          initPath: idMulti + '/' + path.join('/')
        });
      }
      this.sendTrackEvent('flash ok ' + this.flashHeader.deeplink);
    }
  },
  created() {
    this.setListExpanded();

    if (this.initInfos) {
      var path = [];
      if(this.initInfos.path){
        path = this.initInfos.path.split('/');
      }
      var onglet = path.shift();

      var refCulture = this.initInfos.refCulture;
      var refDestination = this.initInfos.refDestination;
      if (refCulture == 'nd' && refDestination == 'nd' && this.listStrategie.length) {
        refCulture = this.listStrategie[0].refCulture;
        refDestination = this.listStrategie[0].refDestination;
      }
      if(refCulture == 'ap'){
        for (let i = 0; i < this.listAppro.length; i++) {
          var approItem = this.listAppro[i];
          if(approItem.refAppro == refDestination){
            if (approItem.negoce.length && (! onglet || onglet == 'n')) {
              var negoceId = path.shift();
              if(negoceId !== undefined){
                for (let j = 0; j < approItem.negoce.length; j++) {
                  var negoceItem = approItem.negoce[j];
                  if(negoceItem.id == negoceId){
                    this.showNegoceAppro(i, negoceId);
                    return;
                  }
                }
              }
              this.showNegoceAppro(i);
              return;
            }
          }
        }
      } else {
        for (let i = 0; i < this.listStrategie.length; i++) {
          var strategieItem = this.listStrategie[i];
          if(strategieItem.refCulture == refCulture && strategieItem.refDestination == refDestination){
  
            if (strategieItem.negoce.length && (! onglet || onglet == 'n' || onglet == 'v')) {
              var negoceId = path.shift();
              if(negoceId !== undefined){
                for (let j = 0; j < strategieItem.negoce.length; j++) {
                  var negoceItem = strategieItem.negoce[j];
                  if(negoceItem.id == negoceId){
                    if(onglet == 'v'){
                      this.showVente(i, negoceId, path.shift());
                    } else {
                      this.showNegocePrix(i, negoceId);
                    }
                    return;
                  }
                }
              }
              if(onglet == 'v'){
                this.showVente(i);
              } else {
                this.showNegocePrix(i);
              }
              return;
  
            } else if (onglet == 'c') {
              var echeance = path.shift();
              if(echeance !== undefined){
                this.showCours(i, echeance);
                return;
              }
              this.showCours(i);
              return;
              
            } else if (onglet == 'a') {
              this.showAlerte(i);
              return;
            }
          }
        }
      }
    }
  }
};
</script>

<style>
.list-item--perfcours__right .list-item__expand-chevron {
  margin-left: 12px;
}
.list-item--perfcours__right .badge {
  font-weight: 500;
  line-height: 18px;
  font-style: normal;
  color: #fff;
  background: #979797;
  border-radius: 3px;
  text-align: center;
  min-width: 52px;
  box-sizing: border-box;
  padding: 0 2px;
}
.list-item--perfcours__right .badge-vert {
  background: var(--perfarmer-vert);
}
.list-item--perfcours__right .badge-rouge {
  background: var(--perfarmer-rouge-erreur);
}
.list-item--perfcours__right .badge-jaune {
  background: var(--perfarmer-jaune);
}
.list-item--perfcours__right div {
  display: inline-block;
}
.list-item--perfcours__right .badge + div,
.list-item--perfcours__right .label-grey + div {
  margin-left: 15px;
  width: 52px;
  box-sizing: border-box;
}
.list-item--perfcours .label-grey,
.list-item--perfalerte__right .label-grey,
.list-item--perfdetail__right .label-grey {
  color: var(--perfarmer-gris-very-dark);
  font-style: italic;
  text-align: right;
}
.list-item--perfcours.list-item--chevron:before,
.list-item--perfalerte.list-item--chevron:before,
.list-item--perfcours .list-item__expand-chevron {
  border-color: var(--perfarmer-gris-light);
}
.list-item--expandpreview {
  background-color: #f2f4f8;
}
.list-item--expandpreview__right .ons-icon {
  font-size: 18px;
}
.list-item--expandpreview__right .ons-icon + div,
.list-item--perfcours__right .ons-icon + div {
  margin-left: 15px;
}
.list-item--expandable.expanded + .list-item--expandpreview {
  display: none;
}
.content--perfhome__quiz,
.content--perfhome__flash {
  margin: 15px;
  background-color: white;
  border-radius: 6px;
  font-size: 18px;
  line-height: 26px;
  color: var(--perfarmer-vert-clair);
  overflow: hidden;
}
.content--perfhome__quiz header {
  min-height: 34px;
}
.content--perfhome__flash header {
  min-height: 110px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.content--perfhome__quiz header span,
.content--perfhome__flash header span {
  float: right;
  margin-top: 6px;
  margin-right: -24px;
  transform: rotate(45deg);
  background-color: var(--perfarmer-vert-clair);
  color: white;
  font-size: 13px;
  font-weight: bold;
  line-height: 30px;
  height: 28px;
  width: 90px;
  text-align: center;
}
.content--perfhome__quiz section,
.content--perfhome__flash section,
.content--perfhome__quiz footer,
.content--perfhome__flash footer {
  padding: 0 22px 26px;
}
.content--perfhome__flash section p {
  margin: 15px 0 10px;
}
.content--perfhome__quiz section {
  display: inline-flex;
}
.content--perfhome__quiz section div,
.content--perfhome__quiz section p {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content--perfhome__quiz section img {
  height: 80px;
}
.content--perfhome__quiz section p {
  margin: 0 0 0 20px;
}
.content--perfhome__quiz section b {
  font-size: 20px;
  line-height: 28px;
  display: block;
}
.content--perfhome__flash section {
  text-align: center;
}
.content--perfhome__flash section span {
  font-weight: 500;
  display: inline-block;
}
.button--outline.button--perflarge {
  border-color: var(--perfarmer-vert-clair);
  color: var(--perfarmer-vert-clair);
}
</style>